/** The payment step piece, standard look over its behavior half. */
import { PaymentStepView } from './PaymentStepView';
import { usePaymentStep, type PaymentStepInput } from './usePaymentStep';

export function PaymentStep(props: PaymentStepInput) {
  return <PaymentStepView {...usePaymentStep(props)} />;
}
